import apiFetch from '../apiFetch'

export default function (eventSubscription, token, userId) {
  const body = {
    notificationEventId: eventSubscription.notificationEventId,
    organizedUnitIds: eventSubscription.organizedUnitIds,
    languageId: eventSubscription.languageId,
    active: eventSubscription.active
  }
  const userIdParam = userId ? `userId=${userId}` : ''
  return apiFetch({ endPoint: `EventSubscription?${userIdParam}`, method: 'POST', body: body, token: token })
}
